/**
 * Aggregates every FAQ Q/A pair on the page into a single FAQPage JSON-LD
 * (per Google's guidance — only one FAQPage per URL).
 *
 * Sources opt in by marking each Q/A pair:
 *   <element data-faq-item>
 *     ...<element data-faq-question>{question text}</element>...
 *     ...<element data-faq-answer>{answer text or rich HTML}</element>...
 *   </element>
 *
 * The script is a no-op on pages with zero items.
 */
(function () {
  function collect() {
    const items = document.querySelectorAll('[data-faq-item]');
    if (!items.length) return null;

    const seen = new Set();
    const mainEntity = [];

    for (const item of items) {
      const qEl = item.querySelector('[data-faq-question]');
      const aEl = item.querySelector('[data-faq-answer]');
      if (!qEl || !aEl) continue;

      const question = (qEl.textContent || '').replace(/\s+/g, ' ').trim();
      // Strip rich HTML to plain text so the schema reflects the visible copy.
      const answer = (aEl.innerText || aEl.textContent || '')
        .replace(/\s+/g, ' ')
        .trim();
      if (!question || !answer) continue;

      const key = question.toLowerCase();
      if (seen.has(key)) continue;
      seen.add(key);

      mainEntity.push({
        '@type': 'Question',
        name: question,
        acceptedAnswer: {'@type': 'Answer', text: answer},
      });
    }

    if (!mainEntity.length) return null;
    return {'@context': 'https://schema.org', '@type': 'FAQPage', mainEntity};
  }

  function emit() {
    const data = collect();
    // Remove any previous emission (re-runs from section editor swaps, etc.)
    document.querySelectorAll('script[data-faq-schema]').forEach((s) => s.remove());
    if (!data) return;
    const tag = document.createElement('script');
    tag.type = 'application/ld+json';
    tag.setAttribute('data-faq-schema', '');
    tag.textContent = JSON.stringify(data);
    document.head.appendChild(tag);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', emit, {once: true});
  } else {
    emit();
  }
})();
